import { useSelector, useDispatch } from "react-redux";

const ToggleButton = () => {

    const { theme  } = useSelector(({ app }) => {
        return app;
    });

    const dispatch = useDispatch();

    const switchStyle = {
        position: "relative",
        display: "inline-block",
        width: "40px",
        height: "20px",
    };

    const inputStyle = {
        opacity: "0",
        width: "0",
        height: "0",
    };

    const sliderStyle = {
        position: "absolute",
        cursor: "pointer",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        border: "1px solid var(--primary-clr-3)",
        backgroundColor: "var(--clr-blue-8)",
        WebkitTransition: ".4s",
        transition: ".4s",
        borderRadius: "25%",
    };

    if (theme === "App--light") {
        sliderStyle.backgroundColor = "#ccc";
    }

    const handleChangeTheme = () => {
        dispatch({type: "APP_SWITCH_THEME"});
    }

    return (
        <label className="switch" style={switchStyle}>
            <input
                style={inputStyle}
                type="checkbox"
                checked={theme === "App--light" ? true : false}
                onChange={handleChangeTheme}
            />
            <span style={sliderStyle} className="slider"></span>
        </label>
    );
};

export default ToggleButton;
